module.exports = __webpack_public_path__ + "static/media/Seventy.76d7be37.ogg";